import { Paper, Tab, Tabs } from '@mui/material';
import { Box } from '@mui/system';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  CustomButton,
  SaveButton,
  SubmitButton,
} from '../../../components/common/button/CustomButtons';
import formatDate from '../../../components/common/formatDate';
import ChildHeader from '../../../components/ui/ChildHeader';
import { useQuery } from '../../../hooks/UseQuery';
import { useAuth } from '../../../services/auth/AuthProvider';
import TController from './create/TController';
import useGetData from './helpers/useGetData';
import { getColumnLength } from '../helpers/utils';
import { GoSync } from 'react-icons/go';
import useConfirm from '../../../components/common/useConfirm';

interface MyData {
  moduleData: any;
  DialogSync: any;
  isLoading: boolean;
  error?: string | null;
}

const Create = () => {
  const { state } = useAuth();
  const navigate = useNavigate();
  const isView = useQuery('isView') === 'true' ? true : false;
  const annual_date = useQuery('annual_date');
  const created_date = useQuery('created_date');
  const employee_id = useQuery('employee_id');
  const [render, setRender] = useState(false);
  const { moduleData, isLoading, error, DialogSync }: MyData = useGetData(
    annual_date,
    created_date,
    employee_id
  );
  const [DialogAddRow, confirmAddRow] = useConfirm(
    'Add Row',
    'Are you sure you want to Add Row?'
  );
  const onSubmit = async (isSubmitted: boolean) => {
    if (moduleData._id) {
      axios
        .put(`/api/salaryRouteContractual/${moduleData._id}`, moduleData)
        .then((res) => {
          window.alert('succesfully updated');
          navigate(-1);
        })
        .catch((err) => console.log(err));
    } else {
      moduleData.employee_id = employee_id;
      moduleData.isSubmitted = isSubmitted;
      moduleData.month_year = annual_date;
      moduleData.created_date = created_date;
      axios
        .post(`/api/salaryRouteContractual`, moduleData)
        .then((res) => {
          window.alert('succesfully updated');
          navigate(-1);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <Box>
      <Box>
        <ChildHeader text="Monthly Salary">
          {!isView && (
            <>
              <CustomButton
                sx={{
                  backgroundColor: '#1c7ed6',
                }}
                onClick={async () => {
                  const ans = await confirmAddRow();
                  if (!ans) return;
                  moduleData.list.push({});
                  setRender((prev) => !prev);
                }}
              >
                ADD ROWS
              </CustomButton>
              <SubmitButton label="Save" onClick={() => onSubmit(true)} />
            </>
          )}
        </ChildHeader>
      </Box>
      <TController
        {...{
          moduleData,
          isView,
        }}
        numberOfDay={getColumnLength(annual_date || '')}
      />
      <DialogSync isSubmitContent={false} />
      <DialogAddRow />
    </Box>
  );
};

export default Create;
